import React, { useState } from "react";
import {
  Breadcrumbs,
  Link,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { ROUTES } from "app/utils/constants/routeConstants";
import { useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import LinkIcon from "components/LinkIcon/LinkIcon";
import useMediaQuery from "@mui/material/useMediaQuery";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";

const Breadcrumb = () => {
  const location = useLocation();
  const { theme } = useJumboTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const capitalizeFirstChar = (str, isLast = false) => {
    if (!str) return str;
    if (isLast) {
      return str
        .split(/[-/]/)
        .filter((word) => word)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }
    // For other segments, capitalize only the first char
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const pathnames = location.pathname.split("/").filter((x) => x);

  const filteredPathnames = [...pathnames];

  if (isMobile) {
    // Mobile View: Show only Home and ellipsis with all pathnames in menu
    return (
      <>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          aria-labelledby="mobile-breadcrumb-menu"
        >
          {filteredPathnames.map((value, index) => {
            const to = "/" + filteredPathnames.slice(0, index + 1).join("/");
            return (
              <MenuItem
                key={index}
                onClick={() => {
                  handleClose();
                  window.location.href = to;
                }}
              >
                {capitalizeFirstChar(value, true)}
              </MenuItem>
            );
          })}
        </Menu>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <LinkIcon icon={HomeIcon} label="Home" href={ROUTES.USER_HOME} />
          {filteredPathnames.length > 0 && (
            <IconButton
              color="primary"
              size="small"
              onClick={handleClick}
              aria-label="More breadcrumbs"
            >
              <MoreHorizIcon />
            </IconButton>
          )}
        </Breadcrumbs>
      </>
    );
  }

  // Desktop View: Show all breadcrumbs
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{ display: "flex", alignItems: "center" }}
    >
      <LinkIcon icon={HomeIcon} label="Home" href={ROUTES.USER_HOME} />
      {filteredPathnames.map((value, index) => {
        const to = "/" + filteredPathnames.slice(0, index + 1).join("/");
        const isLast = index === filteredPathnames.length - 1;

        return isLast ? (
          <Typography key={index} color="text.primary">
            {capitalizeFirstChar(value, true)}{" "}
            {/* Special handling for last segment */}
          </Typography>
        ) : (
          <Link key={index} underline="hover" color="inherit" href={to}>
            {capitalizeFirstChar(value)}{" "}
            {/* Normal first-char capitalization */}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
